<template>
  <v-card class="grey lighten-5" flat>
    <v-toolbar dark class="primary elevation-0" extended>


    </v-toolbar>

    <v-layout row>
      <v-flex xs10 lg8 offset-xs1 offset-lg2>
        <v-card class="card--flex-toolbar">
          <v-app-bar flat class="white" prominent>
            <v-app-bar-title class="body-2 grey--text" v-if="returnShopPortal">
              <v-tooltip top v-if="returnShopPortal.active">
                <template v-slot:activator="{ on }">
                  <v-dialog v-on="on" v-model="dialog" width="500">

                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="green">fiber_manual_record</v-icon>
                    </template>

                    <!-- Deactivate dialog -->
                    <v-card>

                      <v-card-title class="headline" primary-title>
                        Return Shop deactivation
                      </v-card-title>

                      <v-card-text>
                        Please enter the name <b>{{ returnShopPortal.uuid }}</b> in the following text-field to deactivate
                        this return-shop.

                        <v-text-field v-model="returnShopDeleteConfirmation" label="return-shop to deactivate" value=""
                          single-line></v-text-field>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" :disabled="returnShopDeleteConfirmation !== returnShopPortal.uuid"
                          @click="setReturnShopPortalActive(false); dialog = false">deactivate</v-btn>
                      </v-card-actions>
                    </v-card>

                    <!-- Rename dialog -->
                    <v-card>
                      <v-card-title class="headline">
                        Rename Return Shop
                      </v-card-title>

                      <v-card-text>
                        Please enter the new name...

                        <v-text-field v-model="returnShopRenameConfirmation" label="new return-shop name" value=""
                          single-line></v-text-field>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" :disabled="returnShopRenameConfirmation == ''"
                          @click="renameReturnShopPortal(returnShopRenameConfirmation); dialog = false">rename</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </template>
                <span>Umbenennen</span>
              </v-tooltip>

              <v-icon v-else color="red" @click="setReturnShopPortalActive(true)">fiber_manual_record</v-icon>

              <a target="_blank" :href="url">{{ url }}</a>
            </v-app-bar-title>
            <v-spacer></v-spacer>

            <v-tooltip v-for="item in menu" top :key="item.href">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" :href="item.href">
                  <v-icon :class="{ 'blue--text': item.isActive, 'grey--text text--darken-1': !item.isActive }">{{
                    item.icon }}</v-icon>
                </v-btn>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>

          </v-app-bar>
          <v-divider></v-divider>
          <v-card-text style="min-height: 200px;">
            <router-view v-if="done"></router-view>
            <div v-else>loading..</div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<style>
.card--flex-toolbar {
  margin-top: -64px;
}
</style>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {

  data() {
    return {
      returnShopDeleteConfirmation: "",
      returnShopRenameConfirmation: "",
      dialog: false,
      done: true
    }
  },

  mounted() {
    return this.fetch()
  },

  computed: {
    ...mapState('returnShopPortal', [
      'returnShopPortal'
    ]),
    ...mapGetters('returnShopPortal', [
      'uuid',
      'overviewUrl',
      'mappingsUrl',
      'appearanceUrl',
      'settingsUrl',
      'preadviseSettingsUrl',
      'textsUrl',
      'parcelNumberContainersUrl',
      'instructionsDocumentUrl'
    ]),

    url() {
      return `${profileConfig.endpoints.consumerAppUrl}/#/m/${this.$store.getters['returnShopPortal/uuid']}`
    },

    menu() {
      return [
        {
          title: 'Overview',
          icon: 'dashboard',
          href: this.overviewUrl,
          isActive: this.isActive(this.overviewUrl)
        }, {
          title: 'Mappings',
          icon: 'flag',
          href: this.mappingsUrl,
          isActive: this.isActive(this.mappingsUrl)
        }, {
          title: 'Appearance',
          icon: 'color_lens',
          href: this.appearanceUrl,
          isActive: this.isActive(this.appearanceUrl)
        }, {
          title: 'Settings',
          icon: 'settings',
          href: this.settingsUrl,
          isActive: this.isActive(this.settingsUrl)
        }, {
          title: 'Preadvise Settings',
          icon: 'mail',
          href: this.preadviseSettingsUrl,
          isActive: this.isActive(this.preadviseSettingsUrl)
        }, {
          title: 'Texts',
          icon: 'format_align_left',
          href: this.textsUrl,
          isActive: this.isActive(this.textsUrl)
        }, {
          title: 'Parcel Number Containers',
          icon: 'dns',
          href: this.parcelNumberContainersUrl,
          isActive: this.isActive(this.parcelNumberContainersUrl)
        }, {
          title: 'Instruction Document',
          icon: 'content_paste',
          href: this.instructionsDocumentUrl,
          isActive: this.isActive(this.instructionsDocumentUrl)
        }
      ]
    }
  },

  methods: {
    ...mapActions('returnShopPortal', [
      'fetch',
      'setReturnShopPortalActive',
      'renameReturnShopPortal'
    ]),

    isActive(url) {
      return '#' + this.$store.state.route.fullPath === url
    }
  }
}
</script>



// WEBPACK FOOTER //
// GetOuter.vue?586d4d52